import { Typography } from '@mui/material';

export const EmptyCell = () => (
  <Typography variant="body2" color="text.secondary">
    -
  </Typography>
);
